'use strict';

var Marionette = require('backbone.marionette');
var _ = require('underscore');

export default Marionette.View.extend({

  tagName: 'li',
  className: 'group-appointment-list-item',
  template: require('./templates/list-item.hbs'),
  defaults: {
    showStaff: window.SETTINGS.show_staff_picker || window.SETTINGS.show_staff_assigned,
  },
  events: {
    'click': 'onClick',
  },

  initialize: function (options) {
    this.options = _.extend({}, this.defaults, this.options);

    this.listenTo(this.options.staff, 'reset sync', this.render);
  },

  serializeData: function () {
    var staff = this.options.staff.get(this.model.get('staff_id'));

    var json = this.model.toJSON();
    if (this.options.showStaff && staff) {
      json.staff = staff.toJSON();
    } else {
      delete json.staff;
    }
    json.timezone = this.options.timezone;
    json.isFull = this.model.isFull();
    return json;
  },

  onRender: function () {
    if (this.model.isFull()) {
      this.$el.addClass('disabled');
    }
  },

  onClick: function (evt) {
    evt.preventDefault();
    if (!this.model.isFull()) {
      this.triggerMethod('click:appointment', this);
    }
  },

  select: function () {
    this.$el.addClass('active');
  },

});
